import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useForm } from 'react-hook-form';

import { Checkbox, FormControlLabel, FormGroup, TextField, Button } from '@mui/material';

import { EmailRatesSubmitted } from './EmailRatesSubmitted';
import { SignUpWithEmailError } from './SignUpWIthEmailError';

import { Label } from '../../Elements/Label';
import { Loader } from '../../Elements/Loader';

import { LoginForm } from '../../Forms/LoginForm';

import { LOGIN_TO_EMAIL_RATES, HAVE_ACCOUNT } from '../../../constants';

import {
  emailPattern,
  LOGIN_LINK_TEXT,
  Email,
  emailRequired,
  email,
} from '../../../constants/Forms';

import './index.css';

export const EmailRates = ({
  userId,
  handleEmailRates,
  isEmailRatesSubmitted,
  signUpError,
  user,
}) => {
  const [isTermsConditionsChecked, setIsTermsConditionsChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOnLogInForm, setIsOnLogInForm] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  useEffect(() => {
    if (userId) {
      setIsLoggedIn(true);
      setValue('email', user.email);
    }
  }, [userId]);

  const handleOnUpKeyMixPanelTracking = () => {
    mixpanel.track('Email Rates Form', {
      formField: 'Email',
      path: window?.location?.pathname,
    });
  };

  const handleLogin = (value) => {
    setIsOnLogInForm(value);
    mixpanel.track('Email Rates Form', {
      formField: 'Email',
      path: window?.location?.pathname,
    });
  };

  if (isEmailRatesSubmitted && !isLoggedIn) {
    if (!!signUpError) {
      return <SignUpWithEmailError />;
    }

    return <Loader />;
  }

  if (isEmailRatesSubmitted && isLoggedIn) {
    return <EmailRatesSubmitted />;
  }

  if (isOnLogInForm && !isLoggedIn) {
    return (
      <div className="login-form-wrapper">
        <LoginForm
          loginButtonText={LOGIN_TO_EMAIL_RATES}
          path={window?.location?.pathname}
          isOnEmailRatesModal={true}
          handleBacktoEmailRates={() => handleLogin(false)}
        />
      </div>
    );
  }

  return (
    <div className="email-rates-form-wrapper">
      <form onSubmit={handleSubmit(handleEmailRates)}>
        <div className="email-input-wrapper">
          <TextField
            className={email}
            error={!!errors[email]}
            name={email}
            placeholder={Email}
            variant="outlined"
            autoComplete="off"
            disabled={isLoggedIn && !!getValues(email)}
            sx={{
              backgroundColor: 'white',
              borderRadius: '10px',
              marginTop: '5%',
              border: '1px solid black',
            }}
            {...register(email, {
              required: emailRequired,
              pattern: emailPattern,
            })}
            onKeyUp={(e) => handleOnUpKeyMixPanelTracking()}
          />{' '}
          <p className="errors-message">{errors[email]?.message}</p>
        </div>

        {!isLoggedIn && (
          <FormGroup>
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={isTermsConditionsChecked}
                  onChange={() => {
                    setIsTermsConditionsChecked((prevState) => {
                      mixpanel.track('Email Rates Form', {
                        formField: 'Terms and Conditions Checkbox',
                        value: !prevState,
                      });

                      return !prevState;
                    });
                  }}
                />
              }
              label={<Label />}
            />
          </FormGroup>
        )}

        <div className="login-email-rates-row-wrapper">
          <div
            className="account-text-login-wrapper"
            style={{ visibility: isLoggedIn ? 'hidden' : 'initial' }}
          >
            <div className="account-text-wrapper">{HAVE_ACCOUNT}</div>
            <Button
              variant="contained"
              sx={{
                '&:hover': { boxShadow: 'none', textDecoration: 'none' },
                '&:active': { boxShadow: 'none' },
                borderRadius: '10px',
                textTransform: 'initial',
                backgroundColor: 'black',
              }}
              onClick={() => handleLogin(true)}
            >
              {' '}
              {LOGIN_LINK_TEXT}{' '}
            </Button>
          </div>

          <Button
            variant="contained"
            sx={{
              '&:hover': { boxShadow: 'none', textDecoration: 'none' },
              '&:active': { boxShadow: 'none' },
              borderRadius: '10px',
              textTransform: 'initial',
              backgroundColor: 'black',
            }}
            type="submit"
          >
            {' '}
            {Email}{' '}
          </Button>
        </div>
      </form>
    </div>
  );
};
